import React, { Component } from 'react'
import Modal from './Modal'
import ForgotPasswordForm from '../components/ForgotPasswordForm'

const BACKEND_AUTH_URL = 'https://auth.funoro.com'

class ForgotPasswordModal extends Component {
  render () {
    return (
      <Modal title='Reset password'>
        <div className='b-auth-form'>

          <ForgotPasswordForm />

        </div>
      </Modal>
    )
  }
}

export default ForgotPasswordModal



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordModal.js